import { render, staticRenderFns } from "./PeriksaPasien.vue?vue&type=template&id=17e16930&"
import script from "./PeriksaPasien.vue?vue&type=script&lang=js&"
export * from "./PeriksaPasien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports